"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SecureBrand;
(function (SecureBrand) {
    SecureBrand["VisaSecure"] = "visa-secure";
    SecureBrand["MccIdCheck"] = "mcc-id-check";
    SecureBrand["SSL"] = "ssl";
    SecureBrand["PCIDss"] = "pci-dss";
    SecureBrand["Norton"] = "norton";
    SecureBrand["McAffee"] = "mc-affee";
})(SecureBrand || (SecureBrand = {}));
exports.default = SecureBrand;
